import { render, staticRenderFns } from "./AppBarEntrepreneurWaitingRoom.vue?vue&type=template&id=64b22b9d"
import script from "./AppBarEntrepreneurWaitingRoom.vue?vue&type=script&lang=js"
export * from "./AppBarEntrepreneurWaitingRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports